<template>
  <div class="">

    <h3 v-b-toggle.basalam_other_properties class="btn btn-info w-100">
      سایر ویژگی های محصول
      <b-icon icon="arrow-down-circle" />
    </h3>

    <b-collapse id="basalam_other_properties" class="p-2">

      <basalam-attribute v-for="attribute in attributes" :basalamProduct="basalamProduct" :key="attribute.id"
                         :attribute="attribute"/>
    </b-collapse>

  </div>
</template>

<script>

import BasalamAttribute from "@/plugin/components/dashboard/Basalam/BasalamCategoryAttributes/BasalamAttribute.vue";

export default {
  name: "BasalamCategoryAttributes",
  components: {BasalamAttribute},
  props: {
    category: {
      default: null
    },
    basalamProduct: {},
  },
  data() {
    return {
      attributes: []
    }
  },
  methods: {
    async getAttributes() {
      let form = {
        id: this.category.id
      }
      let req = await this.$store.dispatch('Basalam/getCategoryAttributes', form)
      this.attributes = req.data.data[0].attributes;
    },
    translateRequiredValue(attribute) {
      return attribute.required ? 'اجباری' : 'اختیاری'
    }
  },
  watch: {
    category: {
      handler(newValue, oldValue) {
        this.getAttributes();
      },
      deep: true
    }
  }

}
</script>


<style scoped>

</style>